import { FETCH_PLAYER_ASSETS, FETCH_PLAYER_ASSETS_START, FETCH_PLAYER_ASSETS_FAILED } from "../constants/ActionTypes";

const INITIAL_STATE = {
  byType: {
    avatar: [],
    background: [],
    background_music: [],
  },
  // Kept per type so one screen's state cannot mislabel another: the three
  // screens share this reducer and a user can switch between them mid-request.
  errorByType: {},
  loadingByType: {},
  requestIdByType: {},
};

const isCurrent = (state, type, requestId) => requestId === undefined || state.requestIdByType[type] === requestId;

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_PLAYER_ASSETS_START: {
      const { type, requestId } = action.payload || {};
      return {
        ...state,
        loadingByType: { ...state.loadingByType, [type]: true },
        requestIdByType: { ...state.requestIdByType, [type]: requestId },
        errorByType: { ...state.errorByType, [type]: null },
      };
    }
    case FETCH_PLAYER_ASSETS: {
      const { type, assets, requestId } = action.payload || {};
      if (!isCurrent(state, type, requestId)) {
        return state;
      }
      return {
        ...state,
        loadingByType: { ...state.loadingByType, [type]: false },
        byType: {
          ...state.byType,
          [type]: assets || [],
        },
        errorByType: { ...state.errorByType, [type]: null },
      };
    }
    case FETCH_PLAYER_ASSETS_FAILED: {
      const { type, error, requestId } = action.payload || {};
      if (!isCurrent(state, type, requestId)) {
        return state;
      }
      return {
        ...state,
        loadingByType: { ...state.loadingByType, [type]: false },
        errorByType: { ...state.errorByType, [type]: error || "Could not load the list." },
      };
    }
    default:
      return state;
  }
}
